import { render } from "./PublicationsPage.vue?vue&type=template&id=ab2620ca&scoped=true"
import script from "./PublicationsPage.vue?vue&type=script&lang=js"
export * from "./PublicationsPage.vue?vue&type=script&lang=js"

import "./PublicationsPage.vue?vue&type=style&index=0&id=ab2620ca&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ab2620ca"]])

export default __exports__